import axios from "axios";

const deletePatientFavoriteDoctor = async (baseUrl, token, patientId, doctorId) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let deleteResponse = null

    await axios.delete(baseUrl + "/patient/" + patientId + "/fav/?doctorid=" +  doctorId, config)
        .then((res) => {
            //console.log("res.data: ", res.data)
            deleteResponse = {
                status: res.data.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                deleteResponse = {
                    status: error.response.status,
                    result:  error.response.status
                }
            }
        });
    return deleteResponse
}

export default deletePatientFavoriteDoctor;